module.exports = __webpack_public_path__ + "static/media/Serenity soffa 4sits Sense 4001 beige miljö 2024 3.5c146e90.jpg";